import { Entity, MicroMClient } from "@mcurros2/microm";
import { DatosServiciosAutorizacionReportesFiltersDef } from "./DatosServiciosAutorizacionReportesFiltersDef";


export class DatosServiciosAutorizacionReportesFilters extends Entity<DatosServiciosAutorizacionReportesFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DatosServiciosAutorizacionReportesFiltersDef(), parentKeys);
        this.Form = import('./DatosServiciosAutorizacionReportesFiltersForm').then((module) => module.DatosServiciosAutorizacionReportesFiltersForms);
        this.Title = "Filtros de Datos Servicios";
    }
}